/**
 * MSAL configuration for Azure AD authentication
 */

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${
      import.meta.env.VITE_AZURE_AD_TENANT_ID || 'common'
    }`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage' as const,
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    import.meta.env.VITE_AZURE_AD_API_SCOPE || '',
  ].filter(Boolean),
};

export const apiRequest = {
  scopes: [import.meta.env.VITE_AZURE_AD_API_SCOPE || ''].filter(Boolean),
};

export const isDevelopment = import.meta.env.MODE === 'development';
export const bypassEnabled = import.meta.env.VITE_BYPASS_AUTH_ENABLED === 'true';

// Check if Azure AD is properly configured
export const isAzureADConfigured = !!(
  import.meta.env.VITE_AZURE_AD_CLIENT_ID &&
  import.meta.env.VITE_AZURE_AD_TENANT_ID
);